import type { QueryKey } from '@tanstack/react-query';

export const USER_PROFILE_PHOENIX_KEY = (userId: string): QueryKey => [
  `user-profile-phoenix-${userId}`,
];

export const USER_PROFILE_PHOENIX_KEY_APP_EMPLOYEE = (
  userId: string
): QueryKey => ['user-profile-phoenix-app-employee', userId];

export const EMPLOYEE_CARDS_KEY = (): QueryKey => ['employee-cards'];

export const EMPLOYEE_CARD_PIN_KEY = (cardId: string): QueryKey => [
  'employee-card-pin',
  cardId,
];
